export const minecraft1211 = {
  version: '1.21.1',
  title: 'Tricky Trials Update',
  image: 'https://www.minecraft.net/content/dam/minecraftnet/games/minecraft/key-art/Vanilla-PMP_Collection-Carousel-0_Tricky-Trials_1280x768.jpg',
  releases: [
    {
      id: "1B4DY6fn",
      version: "1.0.4",
      date: "May 26, 2025",
      changelog: "Versión estable para Minecraft 1.21.1",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/1.0.4-1.21.1",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: false
    }
  ]
};